module.exports = __webpack_public_path__ + "img/icon_lvjing_shuiguang_normal@2x.a67c642d.png";